import React, { Component } from 'react';
import { has,map} from 'lodash';
import DriverEmergencyHeader from './DriverEmergencyHeader';
import Button from '../common/Button';
import TextInput from '../common/TextInput';
import { appBasePath } from '../../constants/staticData';
import { dateToTime } from '../../helpers';


export default class DriverEmergencyEndJob extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedEmergencyrequest: ''
        };
        this.endJob = this.endJob.bind(this);
    }

    componentWillReceiveProps(next) {
    //this.props.actions.getDriverEmergencyInfo();
      let selectedDataInfo = '';
      let queueInfo = this.props.driveremergencyReducer.driveremergencyinfo.data;
      if(queueInfo){
        if(queueInfo.length > 0 ) {
            map(queueInfo, (info,) => {
              if(info.garagejobquotes.userbookingrequest.requestid == this.props.params.id) {
                selectedDataInfo = info;
              }
            });
            this.setState({selectedEmergencyrequest: selectedDataInfo});
          }
        }
    }

    endJob(){
      let selectedData = this.state.selectedEmergencyrequest.garagejobquotes;
      let startJobData = {
                        "requestId": selectedData.userbookingrequestId,
                        "jobId": selectedData.id,
                        "status": 12
                       }
                       let routeData = appBasePath + '/driver-dashboard';
      this.props.actions.jobRequestStatusChange('driverupdatejobstatus',startJobData,this.props.router,routeData);
    }

    render() {
     const {authReducer, commonReducer,driveremergencyReducer} = this.props;
     let customerInformation = this.state.selectedEmergencyrequest ? this.state.selectedEmergencyrequest.garagejobquotes.userbookingrequest : '';
     const emergencyName = (this.state.selectedEmergencyrequest ? this.state.selectedEmergencyrequest.garagejobquotes.garagejobquotesdetail[0].name : '');
     let garageInfomatiom = (this.state.selectedEmergencyrequest ? this.state.selectedEmergencyrequest.garagejobquotes.garagejobquotesdetail[0]:'');
     let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
     let DateInfo = new Date(customerInformation.createdAt);

            return (
        <div>
        {/*<DriverEmergencyHeader/>*/}
            <div className="container-fluid">
              <div className="row clearfix">
              <DriverEmergencyHeader commonReducer={this.props.commonReducer} actions={this.props.actions} notificationCount={2} profileName="Derrick Frank" notificationCallBack={this.toggleNotification}
               router={this.props.router} displayName={emergencyName} displayLogo="false" driveremergencyReducer={driveremergencyReducer}/>
               {this.state.selectedEmergencyrequest != '' &&
               <div className="driver-emergency-list-container">
          <div className="driver-emergency-main-body">
          <div className="col-xs-12 emergency-display-map-text emergency-display-map-no-border">
              <div className="col-xs-6 emergency-type-data emergency-type-cutomer-name">{customerInformation.username}</div>
              <div className="col-xs-6 text-right emergency-type-data driver-text-blue">{customerInformation.customerPhone}</div>
            </div>
            <div className="col-xs-12 space-btw"></div>
            <div className="col-xs-12">
                <div className="empty-list-display emergeny-end-image">
                       <img src={garageInfomatiom.image} alt="No User Details"></img>
                       <div className="emergency-type-cutomer-name emergency-end-type">{garageInfomatiom.name}</div>
                       <div className="driver-text-grey total-amount-text">Total Amount</div>
                       <div className="total-amount-denomination">{garageInfomatiom.amount} {garageInfomatiom.currency}</div>
                       <div className="col-xs-12 optional-note container-fluid">
                       <TextInput
                            type="text"
                            label="Add Note(Optional)"
                             />
                             </div>
                             <div className="col-xs-12 container-fluid">
                             <div className="col-xs-9 container-fluid text-left driver-requestid driver-text-grey">ID: {customerInformation.requestid}</div>
                             </div>
                             <div className="col-xs-12 container-fluid  driver-date-time driver-text-grey">
                             <div className="col-xs-6 container-fluid text-left">Time: <span>{dateToTime(DateInfo)}</span></div>
                             <div className="col-xs-6 container-fluid  text-right">Date: <span>{months[DateInfo.getMonth()] + ' ' + DateInfo.getDate() + ' , ' + DateInfo.getFullYear()}</span></div>
                             
                             </div>
                </div>
            </div>
          </div>
          </div>
          }
          <div className="driver-button col-xs-12 container-fluid">
               <Button btnType="label" btnSize="sm" fontSize={16} label="End Job" btnCallBack={()=>this.endJob(this)}  customClass="btn-theme-save col-xs-12 driver-end-job-button"/>
               </div>
              </div>
            </div>
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DriverEmergency/DriverEmergencyEndJob.jsx